
document.addEventListener("DOMContentLoaded", function () {
  const footer = document.querySelector('footer')
  const mobFacets = document.querySelector(".mobile-facets__open")
  const mobFacetsClose = document.querySelector(".mobile-facets__close")
  
  mobFacets?.addEventListener('click', function () {
    if(footer){
      footer.style.display = 'none'
    }
  })
  
  mobFacetsClose?.addEventListener('click', function () {
    if(footer){
      footer.style.display = 'block'
    }
  })
})

// fs quantity start

class FSQuantityInput extends HTMLElement {
  constructor() {
    super();

    this.displayInput = this.querySelector('.quantity__input:not(.main)');
    this.mainInput = this.querySelector('.quantity__input.main');

    this.minusButton = this.querySelector('[name="minus"]');
    this.plusButton = this.querySelector('[name="plus"]');

    this.isFabric = this.dataset.fabric === 'true';

    this.step = parseFloat(this.dataset.step) || 1;
    this.multiplier = parseFloat(this.dataset.multiplier) || 1;

    // Read actual bounds from the rendered input attributes,
    // not from dataset (which was never populated).
    this.minDisplay = parseFloat(this.displayInput.min) || 1;
    this.maxDisplay = this.displayInput.max !== '' && !isNaN(parseFloat(this.displayInput.max))
      ? parseFloat(this.displayInput.max)
      : Infinity;

    this.minMain = parseFloat(this.mainInput.min) || (this.minDisplay * this.multiplier);
    this.maxMain = this.mainInput.max !== '' && !isNaN(parseFloat(this.mainInput.max))
      ? parseFloat(this.mainInput.max)
      : Infinity;
  }

  connectedCallback() {
    this.minusButton?.addEventListener('click', () => {
      this.changeQuantity(-this.step);
    });

    this.plusButton?.addEventListener('click', () => {
      this.changeQuantity(this.step);
    });

    this.displayInput?.addEventListener('change', () => {
      this.handleInputChange();
    });

    this.syncValues();
  }

  changeQuantity(amount) {
    let value = this.getDisplayValue();

    value += amount;
    value = this.clampDisplay(value);

    this.setDisplayValue(value);
  }

  handleInputChange() {
    let value = parseFloat(this.displayInput.value);

    if (isNaN(value)) {
      value = this.minDisplay;
    }

    // Round according to step
    value = Math.round(value / this.step) * this.step;
    value = Math.round(value * 10) / 10; // avoid float drift

    value = this.clampDisplay(value);

    this.setDisplayValue(value);
  }

  clampDisplay(value) {
    if (value < this.minDisplay) value = this.minDisplay;
    if (value > this.maxDisplay) value = this.maxDisplay;
    return value;
  }

  getDisplayValue() {
    const value = parseFloat(this.displayInput.value);
    return isNaN(value) ? this.minDisplay : value;
  }

  setDisplayValue(value) {
    value = this.clampDisplay(value);
    value = Math.round(value / this.step) * this.step;
    value = Math.round(value * 10) / 10;
    value = this.clampDisplay(value); // re-clamp after rounding, just in case

    this.displayInput.value = value;

    let mainValue = Math.round(value * this.multiplier);
    mainValue = Math.min(Math.max(mainValue, this.minMain), this.maxMain);

    this.mainInput.value = mainValue;

    this.updateButtonStates(value);
    this.dispatchQuantityChange();
  }

  updateButtonStates(value) {
    if (this.plusButton) {
      this.plusButton.disabled = value >= this.maxDisplay;
    }
    if (this.minusButton) {
      this.minusButton.disabled = value <= this.minDisplay;
    }
  }

  syncValues() {
    let mainValue = parseInt(this.mainInput.value, 10);

    if (isNaN(mainValue) || mainValue < this.minMain) {
      mainValue = this.minMain;
    }
    if (mainValue > this.maxMain) {
      mainValue = this.maxMain;
    }

    this.mainInput.value = mainValue;

    let displayValue = mainValue / this.multiplier;
    displayValue = this.clampDisplay(displayValue);

    this.displayInput.value = displayValue;
    this.updateButtonStates(displayValue);
  }

  dispatchQuantityChange() {
    this.mainInput.dispatchEvent(new Event('input', { bubbles: true }));
    this.mainInput.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

if (!customElements.get('fs-quantity-input')) {
  customElements.define('fs-quantity-input', FSQuantityInput);
}

// fs quantity end

// fs infinite badge start
class FSInfiniteScroller extends HTMLElement {
    constructor() {
        super();
        this.swiper = null;
    }

    connectedCallback() {
        this.pollUntil(
            () => typeof Swiper !== 'undefined',
            this.init.bind(this)
        );
    }

    init() {
        this.swiper = new Swiper(this, {
            slidesPerView: 'auto',
            spaceBetween: 0,
            loop: true,
            autoplay: {
                delay: 0,
                disableOnInteraction: false,
            },
            speed: 3000,
        });
    }

    pollUntil(condition, callback, interval = 1000, maxAttempts = 5) {
        let attempts = 0;
        let killed = false;
        let timeout;

        const poll = () => {
            if (killed) return;

            const result = condition();
            console.log(result);

            if (result) {
                killed = true;
                callback();
                return;
            }

            if (attempts >= maxAttempts) {
                killed = true;
                console.warn('Polling timed out.');
                return;
            }

            attempts++;
            timeout = setTimeout(poll, interval);
        };

        poll();

        return () => {
            killed = true;
            clearTimeout(timeout);
        };
    }
}

if (!customElements.get('fs-infinite-scroller')) {
    customElements.define('fs-infinite-scroller', FSInfiniteScroller);
}
// fs infinite badge end

// announcement bar
class AnnouncementMarquee extends HTMLElement {
  connectedCallback() {
    if (this.swiper) return;

    this.swiper = new Swiper(this.querySelector(".swiper"), {
      slidesPerView: "auto",
      spaceBetween: 0,
      loop: true,
      freeMode: true,
      allowTouchMove: false,
      speed: 20000,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
    });
  }

  disconnectedCallback() {
    this.swiper?.destroy(true, true);
    this.swiper = null;
  }
}

if(!customElements.get("fs-announcement-marquee")){
  customElements.define("fs-announcement-marquee", AnnouncementMarquee);
}




class FsInstaSlider extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const swiper = new Swiper('.fs_insta_slider', {
      slidesPerView: 1.2,
      spaceBetween: 10,
      slidesPerGroup: 1,
      speed: 1000,
      freeMode: true,
      grabCursor: true,
      watchSlidesProgress: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 20,
          speed: 1200,
          freeMode: false,
        },
      },
    });
  }
}
if (!customElements.get('fs-insta-slider')) {
  customElements.define('fs-insta-slider', FsInstaSlider);
}

class FsAiImageSlider extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    if (this.sliderInitialized) return;
    this.sliderInitialized = true;
    const swiperEl = this.querySelector('.swiper');
    const prev = this.querySelector('.swiper-button-prev');
    const next = this.querySelector('.swiper-button-next');

    new Swiper(swiperEl, {
      slidesPerView: 1.4,
      spaceBetween: 20,
      loop: true,
      // freeMode: true,
      // watchOverflow: true,
      navigation: {
        nextEl: next,
        prevEl: prev,
      },
      breakpoints: {
        768: {
          slidesPerView: 5,
          loop: false,
        },
      },
    });
  }
}
if (!customElements.get('fs-ai-image-slider')) {
  customElements.define('fs-ai-image-slider', FsAiImageSlider); 
}


class AnimatedAccordion extends HTMLElement {
  constructor() {
    super();

    this.trigger = this.querySelector('.accordion__trigger');
    this.content = this.querySelector('.accordion__content');

    if (!this.trigger || !this.content) return;

    this.content.style.maxHeight = '0px';
    this.content.style.overflow = 'hidden';

    this.trigger.addEventListener('click', () => this.toggle());
  }

  toggle() {
    const beforeTop = this.trigger.getBoundingClientRect().top;
    const isOpen = this.classList.contains('is-open');

    if (isOpen) {
      this.content.style.maxHeight = `${this.content.scrollHeight}px`;

      requestAnimationFrame(() => {
        this.content.style.maxHeight = '0px';
      });

      this.classList.remove('is-open');
      this.trigger.setAttribute('aria-expanded', 'false');
    } else {
      this.classList.add('is-open');
      this.trigger.setAttribute('aria-expanded', 'true');

      this.content.style.maxHeight = `${this.content.scrollHeight}px`;
    }

    if (window.matchMedia('(min-width: 769px)').matches) {
      setTimeout(() => {
        const rect = this.trigger.getBoundingClientRect();

        const isInViewport =
          rect.top >= 300 &&
          rect.bottom <= window.innerHeight;

        if (isInViewport) return;

        window.scrollBy({
          top: rect.top - 300,
          left: 0,
          behavior: 'smooth'
        });
      }, 300);
    }
  }
}

customElements.define('animated-accordion', AnimatedAccordion);



// pf custom popup
class PfEntryPopup extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.closeBtn = this.querySelector(".close_btn");
    this.closeBtn.addEventListener("click", this.closePopup.bind(this));
    this.addEventListener("click", (e) => {
      if (e.target === this) {
        this.closePopup();
      }
    });

    this.showPopup();
  }
  closePopup() {
    this.classList.remove("active");
  }
  showPopup() {
    const showOneTime = this.getAttribute("one-time");
    const isShow = window.localStorage.getItem("pfEntryPopup");
    window.addEventListener("load", () => {
      if (showOneTime === "true") {
        if (isShow !== "true") {
          this.classList.add("active");
          window.localStorage.setItem("pfEntryPopup", "true");
        }
      } else {
        this.classList.add("active");
      }
    });
  }
}
customElements.define("pf-entry-popup", PfEntryPopup);


// PF Wholesale Management
class WholesaleManagement extends HTMLElement {
  #controller = new AbortController();

  connectedCallback() {
    const { signal } = this.#controller;

    if (!this.isWholesaler && this.hasWholesaleItems()) {
      this.clearWholesaleItems();
    }
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  get isWholesaler() {
    return this.dataset.customerType == "wholesaler";
  }

  get cartProducts() {
    return JSON.parse(this.dataset.cartProducts || "[]");
  }

  get wholesaleCollections() {
    return this.dataset.wholesaleCollections?.split(",") || [];
  }

  get cart() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  hasWholesaleItems() {
    return this.cartProducts.some(product => {
      const productCollections = product.collections?.split(",") || [];

      return productCollections.some(col =>
        this.wholesaleCollections.includes(col.trim())
      );
    });
  }

  // async clearWholesaleItems() {
  //   const sections = this.cart.getSectionsToRender().map(s => s.id);

  //   try {
  //     const response = await fetch(`/cart/clear.js?sections=${sections.join(",")}`, {
  //       method: "POST",
  //       headers: {
  //         "X-Requested-With": "XMLHttpRequest",
  //       }
  //     });

  //     const json = await response.json();

  //     this.cart.renderContents(json, false);
  //   } catch (err) {
  //     console.error("Failed to clear wholesale items:", err);
  //   }
  // }

  async clearWholesaleItems() {
    try {
      await fetch("/cart/clear.js");
      window.location.reload();
    } catch (err) {
      console.error("Failed to clear wholesale items:", err);
    }
  }


  redirect(ifNotType, from, to) {
    if (this.dataset.customerType != ifNotType) {
      const path = window.location.pathname;

      if (path.includes(from)) {
        location.replace(to);
      }
    }
  }
}


if(!customElements.get("pf-wholesale-management")) {
  customElements.define("pf-wholesale-management", WholesaleManagement);
}

// Wholesaler login button
document.addEventListener("DOMContentLoaded", () => {
  const loginBtn = document.querySelector(".pf-wholesale-login button");
  const logoutBtn = document.querySelector(".pf-wholesale-logout button");

  loginBtn?.addEventListener("click", e => {
    e.preventDefault();

    window.location = "/account/login";
  });

  logoutBtn?.addEventListener("click", async e => {
    e.preventDefault();

    await fetch("/cart/clear.js");

    window.location = "/account/logout";
  });

});


// cart
(function (ns, originalFetch) {
  if (typeof originalFetch !== 'function') return;

  ns.fetch = function (...args) {
    const responsePromise = originalFetch.apply(this, args);

    responsePromise.then(async (res) => {
      if (!res.url.includes('cart/change')) return;

      const data = await res.clone().json().catch(() => null);
      if (!data?.items?.length) return;

      const changedItem =
        data?.items_added?.[0] || data?.items_removed?.[0];

      if (!changedItem) return;

      syncAddonQuantities(data, changedItem.sku);
    });

    return responsePromise;
  };

  async function syncAddonQuantities(cart, sku) {
    const mainProduct = cart.items.find(item => item.sku === sku);
    if (!mainProduct) return;

    const addons = cart.items.filter(
      item => item.properties?.SKU === sku
    );

    if (!addons.length) return;

    const updates = addons.reduce((acc, item) => {
      acc[item.key] = mainProduct.quantity;
      return acc;
    }, {});

    await fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    });
  }
})(window, window.fetch);


// megamenu tabs
class FSTabs extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const triggers = this.querySelectorAll('.trigger');
        const tabs = this.querySelectorAll('.tab');

        triggers.forEach(trigger => {
            trigger.addEventListener('click', () => {
                triggers.forEach(trigger => trigger.classList.remove('active'));
                trigger.classList.add('active');

                tabs.forEach(tab => tab.classList.remove('active'));
                const tab = this.querySelector(`.tab[data-tab="${trigger.dataset.tab}"]`);
                tab.classList.add('active');
            });
        });
    }
}

if (!customElements.get('fs-tabs')) {
    customElements.define('fs-tabs', FSTabs);
}


class FSSliderComponent extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    const el = this.querySelector(".swiper");
    if (!el) return;

    this.swiper = new Swiper(el, {
      slidesPerView: 1.2,
      spaceBetween: 10,
      slidesPerGroup: 1,
      loop: true,
      speed: 1000,
      freeMode: true,
      grabCursor: true,
      watchSlidesProgress: true,

      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },

      breakpoints: {
        768: {
          slidesPerView: 3,
          slidesPerGroup: 3, 
          speed: 1200,
          freeMode: false,
        },
      },
    });
  }

  disconnectedCallback() {
    if (this.swiper) this.swiper.destroy(true, true);
  }
}
if (!customElements.get('fs-slider-component')) {
  customElements.define('fs-slider-component', FSSliderComponent);
}


// accordion 
document.addEventListener('DOMContentLoaded', () => {
  const footerMenus = document.querySelectorAll('.footer-block--menu');

  footerMenus.forEach((menu) => {
    const heading = menu.querySelector('.footer-block__heading');

    if (!heading) return;

    heading.addEventListener('click', () => {
      if (window.innerWidth > 749) return;

      menu.classList.toggle('is-open');
    });
  });
});



const sections$1 = {};

const selectors$1 = {
  slider: '[data-slider]',
  item: '[data-item]',
};

const classes$1 = {
  flickityEnabled: 'flickity-enabled',
};

const attributes = {
  sectionId: 'data-section-id',
};

class Slider {
  constructor(section) {
    this.container = section.container;
    this.header = document.querySelector('[data-site-header]');
    this.flkty = null;
    this.resizeEvent = () => {
      this.flkty.resize();
    };

    this.initSlider();
    this.bindScrollButton();
  }

  initSlider() {
    const slidesCount = this.container.querySelectorAll('[data-item]').length;
    const duration = parseInt(this.container.dataset.duration);
    const pageDots = this.container.dataset.pageDots === 'true' && slidesCount > 1;
    const prevNextButtons = this.container.dataset.navArrows === 'true' && slidesCount > 1;
    let autoplay = this.container.dataset.autoplay === 'true';

    if (autoplay) {
      autoplay = duration;
    }

    if (slidesCount > 1) {
      this.flkty = new Flickity(this.container, {
        fade: true,
        cellSelector: '[data-item]',
        autoPlay: autoplay,
        wrapAround: true,
        adaptiveHeight: true,
        setGallerySize: true,
        imagesLoaded: true,
        pageDots: pageDots,
        prevNextButtons: prevNextButtons,
        on: {
          ready: () => {
            const currentStyle = this.container
              .querySelector('[data-item][data-slide-position="1"]')
              .getAttribute('data-style');
            this.container.setAttribute('data-current-style', currentStyle);
            requestAnimationFrame(this.resizeEvent);
            document.addEventListener('theme:vars', this.resizeEvent);
          },
          change: (index) => {
            const currentSlide = this.flkty.selectedElement;
            const currentStyle = currentSlide.getAttribute('data-style');
            this.container.setAttribute('data-current-style', currentStyle);

            this.flkty.cells.forEach((slide, i) => {
              slide.element.querySelectorAll('a, button').forEach((link) => {
                link.setAttribute('tabindex', i === index ? '0' : '-1');
              });
            });
          },
        },
      });

      flickitySmoothScrolling(this.container);
    } else if (slidesCount === 1) {
      const currentStyle = this.container
        .querySelector('[data-item]')
        .getAttribute('data-style');
      this.container.setAttribute('data-current-style', currentStyle);
    }
  }

  bindScrollButton() {
    const arrowDown = this.container.querySelector('[data-scroll-down]');

    if (arrowDown) {
      arrowDown.addEventListener('click', (e) => {
        e.preventDefault();
        const headerFixed = this.header.classList.contains('site-header--fixed');
        const headerHeight = headerFixed ? 60 : 0;
        const scrollToPosition = parseInt(
          Math.ceil(this.container.offsetTop + this.container.offsetHeight - headerHeight)
        );
        window.scrollTo({ top: scrollToPosition, left: 0, behavior: 'smooth' });
      });
    }
  }

  onBlockSelect(evt) {
    const index = parseInt([...evt.target.parentNode.children].indexOf(evt.target));
    if (this.flkty !== null) {
      this.flkty.select(index);
      this.flkty.pausePlayer();
    }
  }

  onBlockDeselect(evt) {
    const autoplay = evt.target.closest('[data-slider]').dataset.autoplay === 'true';
    if (autoplay && this.flkty !== null) {
      this.flkty.playPlayer();
    }
  }

  onReorder() {
    if (this.flkty !== null) {
      this.flkty.resize();
    }
  }

  onUnload() {
    if (this.flkty !== null) {
      document.removeEventListener('theme:vars', this.resizeEvent);
      this.flkty.destroy();
      this.flkty = null;
    }
  }
}

const slider = {
  onLoad() {
    sections$1[this.id] = new Slider(this);
  },
  onReorder(e) {
    sections$1[this.id].onReorder(e);
  },
  onUnload(e) {
    sections$1[this.id].onUnload(e);
  },
  onBlockSelect(e) {
    sections$1[this.id].onBlockSelect(e);
  },
  onBlockDeselect(e) {
    sections$1[this.id].onBlockDeselect(e);
  },
};

register('slider', [slider, videoPlay, zoomAnimation]);





